import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TodayTomorrowDatePipe } from '@sdvor/shared/ui';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { CxDatePipe } from '@spartacus/core';
import { BehaviorSubject } from 'rxjs';
import { ShopListDesktopComponent } from '../desktop/shop-list-desktop.component';

@Component({
  selector: 'sd-shop-list-mobile',
  templateUrl: './shop-list-mobile.component.html',
  styleUrls: ['./shop-list-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [TodayTomorrowDatePipe, CxDatePipe],
  standalone: false,
})
export class ShopListMobileComponent extends ShopListDesktopComponent {
  @Input() mapIsShown$ = new BehaviorSubject<boolean>(false);
  form: FormGroup;
  iconType = CUSTOM_ICON_TYPE;
  DEFAULT_ZOOM = 14;

  confirmShop(id: string): void {
    this.setShopId.emit(id);
    this.setShop(id);
    if (this.closeModalOnConfirm) {
      this.modalService.closeActiveModal();
    }
  }

  clickToListShop(id: string, zoom?: number): void {
    if (this.mapInstance) {
      this.activeId$.next(id);
      if (zoom) {
        this.mapInstance.setZoom(zoom);
      }
      this.selectShopMap(id, false);

      this.mapIsShown$.next(true);
      this.selectShopMap(id, true);
    }
  }

  setShop(id: string): void {
    this.activeId$.next(id);
    this.clickToListShop(id, this.DEFAULT_ZOOM);
    this.scrollToActiveShop();
  }

  toggle(): void {
    this.mapIsShown$.next(!this.mapIsShown$.value);
  }
}
